import React, { useMemo } from 'react';
import { useGetOrganizationsLookup } from 'src/fetch/organizations';
import { FormMultiSelect, FormSelect } from '../formControls';
import { emptyArray } from 'src/shared/helpers/utils';
import { BILLTO_ORGANIZATION_ROLE } from 'src/shared/constants/enums';

const BillToDropdown = (props) => {
  const { data: customerOrganizations = emptyArray, refetch } = useGetOrganizationsLookup({ roles: [BILLTO_ORGANIZATION_ROLE] });

  const calculatedData = useMemo(() => customerOrganizations?.map((x) => ({
    ...x,
    label: x.name,
    value: x.id,
  })), [customerOrganizations]);

  const value = typeof props.value === 'object' ? props.value : calculatedData.find((x) => x.id === props.value);

  const SelectComponent = props.multiSelect ? FormMultiSelect : FormSelect;

  const goesToLink = props.value?.value || props.value
    ? `/organizations/organizations/${props.value?.value ? props.value?.value : props.value}`
    : null;

  const itemRender = (li, itemProps) => {
    const recordNo = itemProps?.dataItem?.value || '';
    const itemChildren = (
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div style={{
          flex: 1,
        }}
        >
          {li.props.children}
        </div>
        {
          recordNo && (
            <div
              style={{
                color: 'gray',
              }}
            >
              {`(${recordNo})`}
            </div>
          )
        }
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  const valueRender = (element) => {
    if (!element.props.value) {
      return element;
    }

    const name = element.props.value;
    const recordNo = customerOrganizations.find((c) => c.label === name)?.value;

    return (
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div style={{
          flex: 1,
        }}
        >
          {element}
        </div>
        {
          recordNo && (
            <div
              style={{
                color: 'gray',
              }}
            >
              {`(${recordNo})`}
            </div>
          )
        }
      </span>
    );
  };

  return (
    <div onClick={refetch} >
      <SelectComponent
        data={calculatedData}
        textField='label'
        dataItemKey='value'
        clearButton={props.clearButton || false}
        goesTo={!props.hideGoesTo ? goesToLink : null}
        {...props}
        itemRender={itemRender}
        value={value}
        // valueRender={valueRender}
      />
    </div>
  );
};

export default BillToDropdown;